import { Dispatcher, isValidWebSocketURL, SocketConnectStatusEnum, toProxy } from "@fanfanlo";
import { IMarketDevConnectEventType, IMarketDevEvent } from "@market/lib";
import { getMarketDevSocketSettingData } from "./market-dev-socket-setting-data";
const dispatcher = new Dispatcher();
interface ISocketConnectInfo{
    status:SocketConnectStatusEnum;
    retryCount:number;
}

export const socketConnectInfo:ISocketConnectInfo = toProxy({
    status:SocketConnectStatusEnum.disconnected,
    retryCount:0
})
let ws:WebSocket|undefined;
async function connect(){
    const url = (await getMarketDevSocketSettingData()).url
    if(!isValidWebSocketURL(url)){
        return;
    }
    socketConnectInfo.status = SocketConnectStatusEnum.connecting;
    const w = ws = new WebSocket(url);
    w.onopen = () => {
        socketConnectInfo.status = SocketConnectStatusEnum.connected;
        toGetAllScripts();
    }
    w.onclose = () => {
        console.log('oscket on close', arguments)
        socketConnectInfo.status = SocketConnectStatusEnum.disconnected;
        checkNeedRetry();
    }
    w.onerror = () => {
        console.log('socket onerror', arguments)
        socketConnectInfo.status = SocketConnectStatusEnum.disconnected;
        close();
        checkNeedRetry();
    }
    w.onmessage = (e:MessageEvent) => {
        try{
            const event:IMarketDevEvent<any> = JSON.parse(e.data)
            console.log('market dev socket onmessage', event.type)
            dispatcher.dispatch(event.type, event.data)
        }catch(e){
            console.error(e)
        }
    }

    async function toGetAllScripts(){
        const event = {type: IMarketDevConnectEventType.getAllScripts}
        w.send(JSON.stringify(event));
    }
}
function close(){
    if(!ws)return;
    ws.close();
    ws = undefined;
}
async function checkNeedRetry(){
    const settingData = await getMarketDevSocketSettingData()
    if(!settingData.keepConnect){
        return;
    }
    socketConnectInfo.retryCount++;
    setTimeout(()=>{
        connect();
    }, 1000 * 5)
}
function disconnect(){
    if(ws){
        ws.close();
        ws = undefined;
    }
    socketConnectInfo.status = SocketConnectStatusEnum.disconnected;
}
export const marketsDevSocket = {
    connect,
    disconnect,
    socketConnectInfo,
    dispatcher
}
